import { Button } from "@/components/ui/button";
import { ArrowRight, Mail } from "lucide-react";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";

export const FinalCTA = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  return (
    <section id="inscription" ref={ref} className="relative py-20 lg:py-28">
      <div className="container mx-auto px-4 lg:px-6 max-w-5xl">
        <motion.div
          initial={{ opacity: 0, y: 30, scale: 0.97 }}
          animate={isInView ? { opacity: 1, y: 0, scale: 1 } : {}}
          transition={{ duration: 0.8, ease: [0.25, 0.46, 0.45, 0.94] }}
          className="relative overflow-hidden rounded-3xl border border-primary/20 bg-gradient-to-br from-primary/[0.08] via-accent/[0.04] to-transparent p-10 lg:p-16 text-center"
        >
          <div className="absolute inset-0 hero-dot-pattern opacity-40" />
          <motion.div
            animate={{ scale: [1, 1.1, 1], opacity: [0.3, 0.5, 0.3] }}
            transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
            className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-primary/20 blur-[120px]"
          />
          <motion.div
            animate={{ scale: [1, 1.15, 1], opacity: [0.2, 0.4, 0.2] }}
            transition={{ duration: 8, repeat: Infinity, ease: "easeInOut", delay: 2 }}
            className="absolute -bottom-32 -left-32 w-96 h-96 rounded-full bg-accent/20 blur-[120px]"
          />

          <div className="relative">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground tracking-tight mb-5">
              Prêt à transformer vos clients occasionnels en{" "}
              <span className="text-gradient">communauté fidèle</span> ?
            </h2>
            <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto mb-10 leading-relaxed">
              Démo gratuite, installation sous 48 heures, sans engagement.
              Si ça ne marche pas pour vous, vous arrêtez quand vous voulez.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
              <Button
                size="lg"
                className="group rounded-xl px-8 h-13 text-base shadow-lg shadow-primary/25 hover:shadow-xl hover:shadow-primary/35 transition-shadow duration-300"
                asChild
              >
                <a href="mailto:cafes@medinafidelite.ma?subject=Inscription%20de%20mon%20commerce">
                  Inscrire mon commerce
                  <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
                </a>
              </Button>
              <Button
                variant="outline"
                size="lg"
                className="rounded-xl px-8 h-13 text-base gap-2 border-border/60 hover:border-primary/30 hover:bg-primary/5"
                asChild
              >
                <a href="mailto:cafes@medinafidelite.ma?subject=Demande%20de%20d%C3%A9mo">
                  <Mail className="h-4 w-4" />
                  Demander une démo
                </a>
              </Button>
            </div>

            <p className="text-xs text-muted-foreground mt-8">
              Aucune carte bancaire requise · Désinscription possible à tout moment ·
              Conforme CNDP
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
